<template>
  <v-col
    cols="12"
    md="12"
  >
    <base-material-card
      color="success"
      class="px-5 py-3"
    >
      <template v-slot:heading>
        <div class="text-h3 font-weight-bolder">
          Facturación proyectada por mes:
        </div>
      </template>
      <v-card-text>
        <v-data-table
          :headers="computedHeaders"
          :items="computedItems"
        >
        </v-data-table>
      </v-card-text>
    </base-material-card>
  </v-col>
</template>

<script>
  import firebase from 'firebase/app'
  export default {
    data () {
      return {
        facturacionProyectada: [],
        asesores: [],
      }
    },
    computed: {
      computedFechas: function () {
        var fechas = ['2021-07', '2021-08', '2021-09', '2021-10', '2021-11', '2021-12', '2022-01', '2022-02', '2022-03', '2022-04', '2022-05', '2022-06', '2022-07', '2022-07', '2022-08', '2022-09', '2022-10', '2022-11', '2022-12']
        const year = new Date().getFullYear()
        var month = new Date().getMonth()
        if (month < 10) {
          month = '0' + month
        }
        const dateNow = year + '-' + month
        const initIndex = fechas.indexOf(dateNow)
        const endIndex = initIndex + 6
        fechas = fechas.slice(initIndex, endIndex)
        return fechas
      },
      computedHeaders: function () {
        const fechas = this.computedFechas
        var headers = []
        headers.push({
          sortable: true,
          text: 'Asesor',
          value: 'asesor',
        })
        fechas.forEach(fecha => {
          headers.push({
            sortable: true,
            text: fecha,
            value: fecha,
          })
        })
        return headers
      },
      computedItems: function () {
        var helper = {}
        var proyectos = []
        var items = []
        proyectos = this.facturacionProyectada.reduce(function (r, o) {
          var key = o.asesor + '-' + o.fechaFactura
          if (!helper[key]) {
            helper[key] = Object.assign({}, o)
            r.push(helper[key])
          } else {
            helper[key].monto += o.monto
          }
          return r
        }, [])
        proyectos = proyectos.sort(function (a, b) {
          return new Date(b.fechaFactura) - new Date(a.fechaFactura)
        })
        const fechas = this.computedFechas
        const asesores = this.asesores
        var resultadosAgrupados = []
        asesores.forEach(asesor => {
          fechas.forEach(fecha => {
            resultadosAgrupados.push({
              asesor: asesor,
              fechaFactura: fecha,
              monto: 0,
            })
            proyectos.forEach(element => {
              if (element.asesor === asesor && element.fechaFactura === fecha) {
                resultadosAgrupados[resultadosAgrupados.findIndex(e => e.asesor === asesor && e.fechaFactura === fecha)].monto = 'S/.' + new Intl.NumberFormat().format(element.monto)
              }
            })
          })
        })
        asesores.forEach(asesor => {
          var itemsEstructurado = null
          itemsEstructurado = {
            asesor: asesor,
          }
          resultadosAgrupados.forEach(element => {
            if (element.asesor === asesor) {
              itemsEstructurado[element.fechaFactura] = element.monto
            }
          })
          items.push(itemsEstructurado)
        })
        return items
      },
    },
    mounted () {
      this.dashboard()
    },
    methods: {
      dashboard () {
        firebase.firestore().collection('users').where('perfil', '==', 'Vendedor').get().then(vendedores => {
          vendedores.forEach(vendedor => {
            this.asesores.push(vendedor.data().email)
            var montoNegociacion = 0
            var totalMontoNegociacion = 0
            var montoGanado = 0
            var totalMontoGanado = 0
            firebase.firestore().collection('proyectos').where('fase', '==', 2).where('asesor', '==', vendedor.data().email).get().then(results => {
              results.forEach(result => {
                if (result.data().estadoNegociacion === 'NEGOCIACIÓN') {
                  montoNegociacion = parseInt(result.data().montoPuertas) + parseInt(result.data().montoCerraduras) + parseInt(result.data().montoCortafuego)
                  totalMontoNegociacion = totalMontoNegociacion + montoNegociacion
                  const data = {
                    asesor: vendedor.data().email,
                    fechaFactura: result.data().dateFechaFacturacion,
                    monto: totalMontoNegociacion,
                  }
                  this.facturacionProyectada.push(data)
                }
                if (result.data().estadoNegociacion === 'GANADO') {
                  montoGanado = parseInt(result.data().montoPuertas) + parseInt(result.data().montoCerraduras) + parseInt(result.data().montoCortafuego)
                  totalMontoGanado = totalMontoGanado + montoGanado
                  const data = {
                    asesor: vendedor.data().email,
                    fechaFactura: result.data().dateFechaFacturacion,
                    monto: totalMontoGanado,
                  }
                  this.facturacionProyectada.push(data)
                }
              })
            })
          })
        })
      },
    },
  }
</script>
